import { map } from 'lodash-es';

export const formatLeads = (leads) =>
  map(leads, ({ segments, ...props }) => ({
    segments: map(segments, ({ id }) => id),
    ...props,
  }));

export const importLead = (json) => {
  const fields = Object.keys(json[0]);

  const replacer = (key, value) => {
    return value === null ? '' : value;
  };
  let csv = map(json, (row) => {
    return map(fields, (fieldName) => {
      return JSON.stringify(row[fieldName], replacer);
    });
  });
  csv.unshift(fields.join(','));
  csv = csv.join('\r\n');
  return csv;
};

export const formatFailedLeads = (headers, rows) => {
  const headerLine = headers.join(',');
  const dataLines = rows.map((row) => row.map((column) => column.value).join(','));
  return [headerLine, ...dataLines].join('\r\n');
};

export const handleQueryString = (object) => {
  let queryString = '';
  Object.entries(object).forEach(([key, value]) => {
    if (value !== '') queryString += `filters[${key}]=${value}&`;
  });
  return queryString.slice(0, -1);
};

export const serialize = (obj, prefix) => {
  const parts = [];
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];
      const newPrefix = prefix ? `${prefix}[${key}]` : key;
      if (Array.isArray(value)) {
        for (let i = 0; i < value.length; i++) {
          parts.push(`${encodeURIComponent(newPrefix)}[]=${encodeURIComponent(value[i])}`);
        }
      } else if (typeof value === 'object' && value !== null) {
        const nested = serialize(value, newPrefix);
        if (nested !== '') {
          parts.push(nested);
        }
      } else {
        parts.push(`${encodeURIComponent(newPrefix)}=${encodeURIComponent(value)}`);
      }
    }
  }
  return parts.join('&');
};

export const removeNullOrEmptyProps = (obj) => {
  const newObj = {};
  Object.keys(obj).forEach((prop) => {
    if (obj[prop] !== null && obj[prop] !== undefined && obj[prop] !== '') {
      newObj[prop] = obj[prop];
    }
  });
  return newObj;
};
